import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { 
  Box,  
  CircularProgress, 
  IconButton, 
  Switch, 
  Table, 
  TableBody, 
  TableCell, 
  TableFooter, 
  TableHead, 
  TablePagination, 
  TableRow, 
  Tooltip, 
  Typography 
} from '@mui/material';

import TablePaginationActions from '../../../../components/utils/TablePaginationActions';
import useTablePaginationInit from '../../../../components/hooks/useTablePaginationInit';
import TableTimeStamps from '../../../../components/utils/TableTimeStamps';
import TopBar from '../../../../components/utils/TopBar';

import EditIcon from '@mui/icons-material/Edit';

import { 
  GetStagesSPTconfig, 
  ToggleStageSPTconfig 
} from '../../../../redux/actions/support/stagesActions';

import IssueStagesModal from './IssueStagesModal';

import global from "../../../../global.scss";
import "./styles.scss";

const IssueStagesPage = () => {
  const dispatch = useDispatch();
  const state = useSelector(state => state["support.config"]);
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [toggling, setToggling] = useState(false);
  const [stagesModalOpen, setStagesModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [update, setUpdate] = useState(null);

  const [stagesList, setStagesList] = useState([]);
  const [stagesTotal, setStagesTotal] = useState(0);

  const [
    page, 
    rowsPerPage,
    handleChangePage, 
    handleChangeRowsPerPage
  ] = useTablePaginationInit();

  useEffect(() => {
    dispatch(GetStagesSPTconfig(page+1, rowsPerPage, setLoading));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  useEffect(() => {
    try {
      formatStagesList(state.stagesList.Records || []);
      setStagesTotal(state.stagesList.Total || 0);
    } catch (err) {
      console.log(err);
    }
  }, [state]);

  // ======================== list formatter ========================
  const formatStagesList = (list) => {
    setStagesList(list);
  }

  const handleToggle = (id) => {
    dispatch(ToggleStageSPTconfig(id, setToggling)).then(() => {
      dispatch(GetStagesSPTconfig(page+1, rowsPerPage, setToggling))
    })
  }

  return (
    <Box>
      <IssueStagesModal 
        open={stagesModalOpen}
        setOpen={setStagesModalOpen}
        title={modalTitle}
        update={update}
        page={page}
        rowsPerPage={rowsPerPage}
        />

      <TopBar
        title={"Stages"}
        button1Text={"Add Stage"}
        button1OnClick={() => {
          setModalTitle("Add Stage");
          setStagesModalOpen(!stagesModalOpen);
        }}
        />

      {
        loading
        ?
        <Box height={"400px"} className="flexCenterCenterRow">
          <CircularProgress />
        </Box>
        :
          stagesList.length === 0
          ?
          <Box height={"200px"} className="flexCenterCenterRow">
            <Typography>No stages found</Typography>
          </Box>
          :
          <Table className="block">
            <TableHead>
              <TableRow>
                <TableCell>Id/Order</TableCell>
                <TableCell>Stage</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Color</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created/Updated on</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                stagesList.map((row, index) => (
                  <TableRow 
                    key={index}>
                    <TableCell>{row.Id}</TableCell>
                    <TableCell>{row.Title}</TableCell>
                    <TableCell>{row.Description}</TableCell>
                    <TableCell>
                      <Box
                        sx={{ width: "100px", height: "30px", backgroundColor: "#"+row.Color}}>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Switch
                        checked={row.Status} 
                        onChange={(e) => {
                          handleToggle(row.Id);
                        }}
                        />
                    </TableCell>
                    <TableCell>
                      <TableTimeStamps
                        createdAt={row.createdAt}
                        updatedAt={row.updatedAt} 
                        />
                    </TableCell>
                    <TableCell>
                      <Tooltip
                        title={"Edit Stage:" + row.Title}>
                        <IconButton
                          onClick={() => {
                            setUpdate(row);
                            setModalTitle("Edit Stage " + row.Title);
                            setStagesModalOpen(!stagesModalOpen);
                          }}>
                          <EditIcon sx={{ color: global["primary_light"] }}/>
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  sx={{ borderBottom: 0 }}
                   rowsPerPageOptions={[5, 10, 25, 50, 100]} 
                  colSpan={10}
                  count={stagesTotal}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      'aria-label': 'rows per page'
                    },
                    native: true
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                  />
              </TableRow>
            </TableFooter>
          </Table>
      }
    </Box>
  )
}

export default IssueStagesPage;